import { Component, OnInit, Output, EventEmitter, Input, ElementRef, OnChanges, SimpleChanges, ViewChild, forwardRef } from '@angular/core';
import { NgbDateParserFormatter, NgbDate, NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { NgForm, FormGroup, FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-form-input-calendar',
  templateUrl: './form-input-calendar.component.html',
  styleUrls: ['./form-input-calendar.component.scss'],
  providers: [
    //Requerido para implementar ControlValueAccessor [(ngModel)]
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputCalendarComponent),
      multi: true
    }
  ]
})
export class FormInputCalendarComponent implements ControlValueAccessor, OnInit, OnChanges {

  isDisabled;

  @Input()
  placeholder = String;

  @Input()
  minDate: Date;

  @Input()
  maxDate: Date;

  @Input()
  public inputClass: string;

  @Input()
  public showValidClass: boolean = false;

  public invalid: boolean;

  modelValue: Date;
  ngDate: NgbDateStruct = null;
  lastValue: NgbDateStruct;
  hiddenInputValue: string;

  constructor(private parserFormatter: NgbDateParserFormatter) {
  }

  ngOnInit() {
    if (this.modelValue) {
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setIsValid();
  }

  writeValue(value: Date): void {
    this.modelValue = value;
    if (value && !this.ngDate) {
      this.ngDate = {
        day: value.getDate(),
        month: value.getMonth() + 1,
        year: value.getFullYear()
      }
    }
    else if (value === null && this.ngDate) {
      this.ngDate = null;
    }
    this.setIsValid();
    this.onTouch();
    this.onChange(this.modelValue);
  }

  setIsValid() {
    if (!this.ngDate || this.ngDate.year) {
      this.invalid = false;

      if (this.modelValue && this.minDate && this.minDate > this.modelValue) {
        this.invalid = true;
      } else if (this.maxDate && this.maxDate < this.modelValue) {
        this.invalid = true;
      }
    } else {
      this.invalid = true;
    }
  }

  writeNgDateStruct(value: NgbDateStruct): void {
    if (!this.ngDate || this.ngDate.year) {
      if (this.ngDate) {
        this.writeValue(new Date(value.year, value.month - 1, value.day));
      } else {
        this.writeValue(null);
      }
    }
    else {
      this.writeValue(undefined);
    }
  }


  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onTouch() {

  }

  onChange(value: Date) {

  }

  modelChanged(date: NgbDateStruct) {
    this.writeNgDateStruct(date);
  }
}
